import React from 'react';
import { useTranslation } from 'react-i18next';
import ScrollableAnchor from 'react-scrollable-anchor';

const SummaryFieldRead = ({ summaryValue }) => {
  const { t: translator } = useTranslation();

  return (
    <div
      className="create-hearing-form-field"
      aria-label={translator('ariaLabel.summaryFieldRead')}
    >
      <ScrollableAnchor id={'summary'}>
        <div className="hearing-resume">
          <hr className="create-hearing-header-hr" />
          <h2 className="h2-style">
            {translator('hearingProperties.summary')}
          </h2>
          <p> {summaryValue || '-'} </p>
        </div>
      </ScrollableAnchor>
    </div>
  );
};

export { SummaryFieldRead };
